class PiViewToggle extends HTMLElement {
  constructor() {
    super();
    this.currentView = this.dataset.initialView || 'default';
    this.button = this.querySelector('.pi-view-toggle__button');
    this.icons = this.querySelectorAll('.pi-view-toggle__icon');
    this.maxColumns = parseInt(this.dataset.maxColumns || this.icons.length || '3', 10);
    this.gridSelector = this.dataset.gridSelector || '#product-grid';
    this.containerSelector = this.dataset.containerSelector || '#ProductGridContainer';
    this.defaultDesktopClass = null;
    this.defaultMobileClass = null;
    
    this.getProductGrid();
    this.storeDefaultClasses();
    
    if (this.button) {
      this.button.addEventListener('click', this.handleClick.bind(this));
    }

    this.handleResize = this.handleResize.bind(this);
    window.addEventListener('resize', this.handleResize);
    
    this.observeGridUpdates();
    
    this.updateIcons();
    if (this.productGrid) {
      this.applyView();
    } else {
      setTimeout(() => {
        if (this.getProductGrid()) {
          this.storeDefaultClasses();
          this.applyView();
        }
      }, 300);
    }
  }

  storeDefaultClasses() {
    if (!this.productGrid) return;
    
    const allClasses = Array.from(this.productGrid.classList);
    
    const desktopClass = allClasses.find(className => className.match(/^grid--\d+-col-desktop$/));
    if (desktopClass) {
      this.defaultDesktopClass = desktopClass;
    }
    
    const mobileClass = allClasses.find(className => className.match(/^grid--\d+-col-tablet-down$/));
    if (mobileClass) {
      this.defaultMobileClass = mobileClass;
    }
  }

  getProductGrid() {
    this.productGrid = document.querySelector(this.gridSelector);
    if (this.productGrid) {
      this.productGrid.classList.add('pi-view-toggle-grid');
    }
    return this.productGrid;
  }

  observeGridUpdates() {
    const gridContainer = document.querySelector(this.containerSelector);
    if (!gridContainer) {
      return;
    }

    const observer = new MutationObserver((mutations) => {
      let gridUpdated = false;
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1) {
              if (
                (node.matches && node.matches(this.gridSelector)) ||
                (node.querySelector && node.querySelector(this.gridSelector))
              ) {
                gridUpdated = true;
              }
            }
          });
          
          if (mutation.addedNodes.length > 0 || mutation.removedNodes.length > 0) {
            gridUpdated = true;
          }
        }
      });
      
      if (gridUpdated) {
        setTimeout(() => {
          this.getProductGrid();
          if (this.productGrid) {
            this.storeDefaultClasses();
            this.applyView();
          }
        }, 150);
      }
    });

    observer.observe(gridContainer, {
      childList: true,
      subtree: true
    });
    
    document.addEventListener('facet:updated', () => {
      setTimeout(() => {
        this.getProductGrid();
        if (this.productGrid) {
          this.storeDefaultClasses();
          this.applyView();
        }
      }, 150);
    });
  }

  handleClick() {
    if (!this.icons.length) return;
    const activeColumns = this.getActiveColumnCount();
    const nextView = activeColumns >= this.maxColumns ? 1 : activeColumns + 1;
    this.currentView = String(nextView);
    
    this.applyView();
    this.updateIcons();
  }

  handleResize() {
    this.updateIcons();
  }

  applyView() {
    if (!this.getProductGrid()) {
      setTimeout(() => {
        if (this.getProductGrid()) {
          this.storeDefaultClasses();
          this.applyView();
        }
      }, 200);
      return;
    }
    
    if (!this.defaultDesktopClass || !this.defaultMobileClass) {
      this.storeDefaultClasses();
    }
    
    const allClasses = Array.from(this.productGrid.classList);
    allClasses.forEach(className => {
      if (className.match(/^grid--\d+-col-(desktop|tablet-down)$/)) {
        this.productGrid.classList.remove(className);
      }
    });
    
    if (this.currentView === 'default') {
      if (this.defaultDesktopClass) {
        this.productGrid.classList.add(this.defaultDesktopClass);
      }
      if (this.defaultMobileClass) {
        this.productGrid.classList.add(this.defaultMobileClass);
      }
      
      if (!this.defaultDesktopClass) {
        this.productGrid.classList.add('grid--4-col-desktop');
      }
      if (!this.defaultMobileClass) {
        this.productGrid.classList.add('grid--2-col-tablet-down');
      }
    } else {
      const columns = this.currentView;
      this.productGrid.classList.add(`grid--${columns}-col-desktop`);
      this.productGrid.classList.add(`grid--${columns}-col-tablet-down`);
    }
  }

  getActiveColumnCount() {
    const isMobileView = window.matchMedia('(max-width: 989px)').matches;
    const sourceClass =
      this.currentView === 'default'
        ? (isMobileView ? this.defaultMobileClass : this.defaultDesktopClass)
        : `grid--${this.currentView}-col-${isMobileView ? 'tablet-down' : 'desktop'}`;
    const match = sourceClass ? sourceClass.match(/^grid--(\d+)-col-(desktop|tablet-down)$/) : null;
    return match ? parseInt(match[1], 10) : 1;
  }

  updateIcons() {
    if (!this.icons || this.icons.length === 0) return;
    const activeColumns = this.getActiveColumnCount();
    
    this.icons.forEach((icon, index) => {
      const columns = index + 1;
      icon.classList.remove('pi-view-toggle__icon--active');
      
      if (columns <= activeColumns) {
        icon.classList.add('pi-view-toggle__icon--active');
      }
    });
  }
}

if (!customElements.get('pi-view-toggle')) {
  customElements.define('pi-view-toggle', PiViewToggle);
}

